import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_CONFERENCE_ID, useStateContext } from '../../Contexts/ContextProvider';
import AxiosClient from '../../assets/AxiosClient';
import FillesRow from './FillesRow';
import ToggleSwitch from '../../Models/ToggleSwitch';
import Loader from '../../assets/tools/Loder/loader';

const Files = () => {
  const { SetNotification } = useStateContext();
  const [files, setFiles] = useState([]);
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [filesPerPage] = useState(10); // Set the number of files per page
  const [conferenceId, setConferenceId] = useState(DEFAULT_CONFERENCE_ID);
  const [lang, setLang] = useState('English'); // Language filter
  const [isActive, setIsActive] = useState(1); // For active filter (public vs not public)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get('/public-files');
        const _files = await response.data;
        setFiles(_files);
        setLoading(false);
      } catch (error) {
        SetNotification('Error fetching data', 'danger');
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const filterFiles = () => {
      let filtered = files;

      // Filter by conference
      if (conferenceId) {
        filtered = filtered.filter((file) => file.conference.id === conferenceId);
      }

      // Filter by language
      filtered = filtered.filter((file) => file.lang === lang);

      // Filter by active (public or not public)
      filtered = filtered.filter((file) => file.active == isActive);

      setFilteredFiles(filtered);
    };

    filterFiles();
  }, [files, conferenceId, lang, isActive]); // Added isActive to the dependency array

  // Pagination logic
  const indexOfLastFile = currentPage * filesPerPage;
  const indexOfFirstFile = indexOfLastFile - filesPerPage;
  const currentFiles = filteredFiles.slice(indexOfFirstFile, indexOfLastFile);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div> 
        <Link className="btn btn-dark m-2" to="./Add">
          <i className="material-icons">add_box</i> | Add a new File
        </Link> 
        <br/>
      </div>
      <div className="m-3 d-flex">
        <div>
          <label className="h6 mb-0 h6 m-3">Language</label>
          <button
            className={`btn btn-${lang === 'Arabic' ? 'info' : 'dark'} m-2`}
            onClick={() => setLang('Arabic')}
          >
            Arabic
          </button>
          <button
            className={`btn btn-${lang === 'English' ? 'info' : 'dark'} m-2`}
            onClick={() => setLang('English')}
          >
            English
          </button>
          {lang === 'Arabic' ? (
            <img src="https://flagsapi.com/IQ/shiny/64.png" alt="Arabic" />
          ) : (
            <img src="https://flagsapi.com/GB/shiny/64.png" alt="English" />
          )}
        </div>

        <div className="w-full flex flex-wrap items-center mx-4 ">
          <label className='h6'> File public</label>
          <ToggleSwitch 
            message="" 
            state={isActive} 
            updateIsActive={setIsActive} 
          />
        </div>
      </div>
      
      <div className="card-body px-0 pb-2">
        <div className="p-0 text-center">
          {loading ? (
            <Loader label="Loading files..." />
          ) : (
            <table className="table align-items-center justify-content-center mb-0">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>State</th>
                  <th>Conference</th>
                  <th>Description</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentFiles.length > 0 ? (
                  currentFiles.map((file) => (
                    <FillesRow
                      key={file.id}
                      title={file.title}
                      description={file.description}
                      conference={file.conference}
                      active={file.active}
                      link={file.link}
                      id={file.id}
                    />
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No files available for this filter</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div className="pagination m-2 p-2">
          {filteredFiles.length > filesPerPage && (
            <ul className="pagination m-2">
              {Array(Math.ceil(filteredFiles.length / filesPerPage))
                .fill()
                .map((_, index) => (
                  <li key={index} className="page-item">
                    <button className="page-link" onClick={() => paginate(index + 1)}>
                      {index + 1}
                    </button>
                  </li>
                ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default Files;
